import { Box } from "@mui/material";
import { Button } from "../../../../shared/components/button/Button";
import { Loader } from "../../../../shared/components/Loader";
import * as Icon from '@mui/icons-material/';
import { HeaderComponent } from "../../../../shared/components/HeaderComponent";
import FormBuilder from "../../../../shared/components/FormBuilder";
import useReajusteEstoqueCadastrar from "../../../../hooks/useReajusteEstoqueCadastrar";
import { useCallback, useRef, useState } from "react";
import ClienteController from "../../../../controllers/ClienteController";
import ProdutoController from "../../../../controllers/ProdutoController";
import { FormikProps } from "formik";
import { ReajusteEstoqueSchema } from "../../../../schemas/ReajusteEstoqueDetalheSchema";

export default function ReajusteEstoqueCadastrar() {
    const {
        initialValues,
        handleSubmit,
    } = useReajusteEstoqueCadastrar();

    const [responsaveis, setResponsaveis] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const formRef = useRef<FormikProps<any>>(null);
    const debounceRef = useRef<NodeJS.Timeout | null>(null);

    const fetchResponsaveis = useCallback(async (v) => {
        if (!v) return; //Evita busca vazia
        const response = await ClienteController.ListarVendedor(v);
        if (response.StatusCode === 200) {
            return setResponsaveis(response.Data || []);
        }
        setResponsaveis([])
    }, []);

    const fetchProdutos = useCallback(async (p) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(async () => {
            if (!p) return;
            const response = await ProdutoController.Listar({ ProdutoId: null, Descricao: p, CodigoBarras: '', PartNumber: '', Grupo: '' });
            if (response.StatusCode === 200) {
                setProdutos(response.Data || []);
                formRef.current?.setFieldValue('qtd_atual', response.Data[0]?.prod_estoque || 0);
            } else {
                setProdutos([]);
            }
        }, 500);
    }, []);

    const handleTriggerSubmit = () => {
        console.log('handleTriggerSubmit chamado');
        if (formRef.current) {
            formRef.current.submitForm();
        }
    };

    const handleCalcularDiferenca = (e: any) => {
        const valorDigitado = e.target.value ? Number(e.target.value) : 0;
        const qtdAtual = Number(formRef.current?.values?.qtd_atual || 0);
        const calculo = valorDigitado - qtdAtual;
        formRef.current?.setFieldValue('diferenca', calculo);
    };

    const fields = [
        //{ name: 'est_id', type: 'number', label: 'Código', disabled: true },
        { name: 'responsavel', type: 'autocomplete', label: 'Responsável', col: 12, options: responsaveis, optionKey: "cli_id", optionLabel: 'cli_nome', required: true, onInput: (_, v: any) => fetchResponsaveis(v) },
        { name: 'prod_descricao', type: 'autocomplete', label: 'Produto', col: 12, options: produtos, optionKey: "prod_id", optionLabel: 'prod_descricao', required: true, onInput: (_, p: any) => fetchProdutos(p) },
        { name: 'est_dataInc', type: 'date', label: 'Data', disabled: true, col: 2 },
        { name: 'qtd_atual', type: 'number', label: 'Qtd. Atual', col: 2, disabled: true, InputLabelProps: { shrink: true } },
        { name: 'qtd_real', type: 'number', label: 'Qtd. Real', col: 2, onInput: handleCalcularDiferenca },
        { name: 'diferenca', type: 'number', label: 'Diferença', col: 2, disabled: true, InputLabelProps: { shrink: true } },
        { name: 'ocorrencia', type: 'text', label: 'Ocorrência', col: 12, multiline: true, rows: 4 },
    ];


    return (
        <Loader loading={false}>
            <Box>
                <HeaderComponent text={'Cadastrar Reajuste de Estoque'}
                    ButtonRight={
                        <Button title={'Salvar'} variant='success' onClick={handleTriggerSubmit} iconStart={<Icon.Save />} />
                    }
                />
                <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} innerRef={formRef} validationSchema={ReajusteEstoqueSchema} />
            </Box>
        </Loader>
    );
}